import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { SelectBetweenDatetime } from '../../components/popups/select-between-datetime/select-between-datetime';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationTicketsListPage } from '../../configuration/configuration-tickets/configuration-tickets-list/configuration-tickets-list';
import { CustomServices } from '../services';

/**
 * Generated class for the TicketsListArrosseriaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-tickets-list-arrosseria',
    templateUrl: 'tickets-list-arrosseria.html',
})
export class TicketsListArrosseriaPage {

    element_type: any = 'closed';
    searchbar_text: string = '';
    date_first: any;
    date_last: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public customServices: CustomServices,
        public globals: Globals,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        public toastCtrl: ToastController,
        public modalCtrl: ModalController) {

        this.globals.GAtrackView('Sales', 'Sales - Tickets - List', this.globals.restaurant.email, 'View', 'List tickets', 'Sales', '');

        //init dates
        this.date_first = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss');
        this.date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    }

    /**********************************************************/
    /*                          INIT                          */
    /**********************************************************/

    ionViewWillEnter() {

        if (!this.globals.checkLimitsByLicense('sales', 'tickets')) {
            this.navCtrl.pop();
            this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {

            let loadingPopup = this.loadingCtrl.create({
                spinner: 'crescent',
                content: this.translate.instant('instant-cargando-tickets')
            });
            loadingPopup.present();
            this.customServices.getPagesTickets(50, this.element_type, this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'));
            this.searchTicketsNode(this.searchbar_text);
            loadingPopup.dismiss();
        }
    }

    /**********************************************************/
    /*                        FUNCIONES                       */
    /**********************************************************/

    //funcion que abre el modal para seleccionar fechas
    openSelectDatetimeModal() {
        let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
            title: this.translate.instant('general-tickets-pagados'),
            date_first: this.date_first,
            date_last: this.date_last,
            cash_bool: false,

        });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.date_first = data.date_first;
                this.date_last = data.date_last;
                this.searchTickets();
            }
        });
        profileModal.present();
    }

    //funcion que busca los tickets por las fechas elegidas
    searchTickets() {
        this.customServices.page_active = 1;
        this.customServices.getPagesTickets(50, this.element_type, this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'));
        this.searchTicketsNode(this.searchbar_text)
    }

    //funcion que filtra por valor que queremos
    searchTicketsNode(value) {
        this.searchbar_text = value; //Guardamos el valor del searchbar
        if (value.target) {
            this.customServices.searchTicketsNode(value, this.element_type, this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'));
        }
    }

    //
    trFontColor(ticket) {
        if (ticket.refund && ticket.amount < 0) {
            let cssClasses = {
                'text-danger': true,
            };
            return cssClasses;
        }
        return '';
    }

    /**********************************************************/
    /*                       PAGINATORS                       */
    /**********************************************************/

    nextPage() {
        if (this.customServices.page_active < this.customServices.pagesTickets.length) {
            this.customServices.page_active += 1
        }
        this.customServices.getListTickets();
        document.getElementById('scroll_ticket').scrollIntoView({
            behavior: 'smooth'
        });
    }
    previusPage() {
        if (this.customServices.page_active > 1) {
            this.customServices.page_active -= 1;
        }
        this.customServices.getListTickets();
        document.getElementById('scroll_ticket').scrollIntoView({
            behavior: 'smooth'
        });
    }
    activePage(number) {
        this.customServices.page_active = number;
        this.customServices.getListTickets();
        document.getElementById('scroll_ticket').scrollIntoView({
            behavior: 'smooth'
        });
    }

    /**********************************************************/
    /*                         NAVCTRL                        */
    /**********************************************************/

    openTicket(ticket) {
        this.navCtrl.push(ConfigurationTicketsListPage, {
            state: 'closed',
            ticket: ticket,
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/custom/tickets-list-arrosseria/tickets-list-arrosseria.ts